import { KartoyIcon, type KartoyIconName } from '@mobile/components/kartoy/kartoy-icon'
import { useAppTheme } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'
import { memo } from 'react'
import { Pressable } from 'react-native'
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated'

import { useCreateStyles } from './styles'

const AnimatedPressable = Animated.createAnimatedComponent(Pressable)

type IconButtonProps = {
  icon: KartoyIconName
  onPress?: () => void
  size?: number
  iconSize?: number
  backgroundColor?: string
}

// Круглая иконочная кнопка (bg из темы, по умолчанию surface): press — scale + затемнение.
export const IconButton = memo(function IconButtonComponent({
  icon,
  onPress,
  size = 48,
  iconSize = 24,
  backgroundColor,
}: IconButtonProps) {
  const theme = useAppTheme()
  const styles = useCreateStyles()
  const press = useSharedValue(0)

  const idleBg = backgroundColor ?? theme.COLOR_BG_SURFACE
  const pressedBg = theme.COLOR_BG_FILL

  // Размеры — на JS-стороне: rw/rh не ворклеты, в UI-потоке их звать нельзя
  const buttonSize = rw(size)

  const animatedStyle = useAnimatedStyle(
    () => ({
      backgroundColor: press.value > 0.5 ? pressedBg : idleBg,
      height: buttonSize,
      transform: [{ scale: 1 - press.value * 0.06 }],
      width: buttonSize,
    }),
    [press, pressedBg, idleBg, buttonSize],
  )

  return (
    <AnimatedPressable
      accessibilityRole="button"
      onPress={onPress}
      onPressIn={() => {
        press.value = withTiming(1, { duration: 90 })
      }}
      onPressOut={() => {
        press.value = withTiming(0, { duration: 150 })
      }}
      style={[styles.button, animatedStyle]}
    >
      <KartoyIcon icon={icon} size={iconSize} />
    </AnimatedPressable>
  )
})
